export const hasTriggerButtonValidateError = (hasErrorValidate) => {
  if (Array.isArray(hasErrorValidate)) return hasErrorValidate.length > 0

  return !!hasErrorValidate
}

export const getTriggerButtonIsValidate = (hasErrorValidate) =>
  !hasTriggerButtonValidateError(hasErrorValidate)

export const shouldStopTriggerButtonAction = ({
  waitAction,
  hasErrorValidate,
} = {}) => waitAction === true && hasTriggerButtonValidateError(hasErrorValidate)

export const createTriggerButtonValidateResponse = ({
  formData = {},
  hasErrorValidate,
  message = '',
} = {}) => {
  const isValidate = getTriggerButtonIsValidate(hasErrorValidate)

  return {
    status: isValidate ? 200 : -2,
    message,
    data: formData,
    isValidate,
  }
}

export const createTriggerButtonResultWithValidate = ({
  response,
  formData = {},
  hasErrorValidate,
} = {}) => {
  const validateResponse = createTriggerButtonValidateResponse({
    formData,
    hasErrorValidate,
  })

  if (!response) return validateResponse

  if (Array.isArray(response)) {
    return Object.assign([...response], {
      isValidate: validateResponse.isValidate,
    })
  }

  return {
    ...response,
    isValidate: validateResponse.isValidate,
  }
}
